import type { TreeViewSelectNode } from '../../../TreeViewSelect';
import type { DiamRoleDetails } from '../../diamApi';
import {
  collectFunctionalRoleAttributeIds,
  scopeCreateRoleContentId,
} from '../CreateRoleDrawer/mapCreateRoleContentsTree';
import type { RolePermissionNode } from './types';

export function mapCreateRoleContentsToPermissionNodes(
  nodes: readonly TreeViewSelectNode[],
): RolePermissionNode[] {
  return nodes.map(node => ({
    id: node.id,
    label: node.label,
    children: node.children?.length
      ? mapCreateRoleContentsToPermissionNodes(node.children)
      : undefined,
  }));
}

export function mapApiSelectionToCatalogSelection(
  functionalRoles: readonly DiamRoleDetails[],
  apiSelectedIds: readonly string[],
): string[] {
  const apiIds = new Set(apiSelectedIds);
  const catalogIds = new Set<string>();

  for (const role of functionalRoles) {
    if (role.type !== 'FUNCTIONAL') {
      continue;
    }

    const roleSelectionId = `role:${role.roleId}`;
    const groupSelectionId = `group:${role.roleId}`;
    const attributeIds = collectFunctionalRoleAttributeIds(role);

    if (apiIds.has(roleSelectionId)) {
      catalogIds.add(groupSelectionId);
      catalogIds.add(roleSelectionId);
      for (const attributeId of attributeIds) {
        catalogIds.add(scopeCreateRoleContentId(role.roleId, attributeId));
      }
      continue;
    }

    const selectedAttributeIds = attributeIds.filter(attributeId =>
      apiIds.has(attributeId),
    );

    if (selectedAttributeIds.length === 0) {
      continue;
    }

    for (const attributeId of selectedAttributeIds) {
      catalogIds.add(scopeCreateRoleContentId(role.roleId, attributeId));
    }

    if (
      attributeIds.length > 0 &&
      selectedAttributeIds.length === attributeIds.length
    ) {
      catalogIds.add(groupSelectionId);
    }
  }

  return Array.from(catalogIds);
}
